(() => {
  if (window.homepageCcAnimateBound) return;
  window.homepageCcAnimateBound = true;

  document.documentElement.classList.add('cc-animate-enabled');
  document.body?.classList.add('cc-animate-enabled');

  const reveal = (element) => {
    element.classList.add('cc-animate-in');
  };

  const assignStaggerDelays = () => {
    document.querySelectorAll('[data-cc-animate-stagger]').forEach((group) => {
      const items = [...group.querySelectorAll('[data-cc-animate]')].filter((item) => item !== group);
      items
        .sort((a, b) => {
          const aRect = a.getBoundingClientRect();
          const bRect = b.getBoundingClientRect();
          return Math.abs(aRect.top - bRect.top) > 8 ? aRect.top - bRect.top : aRect.left - bRect.left;
        })
        .forEach((item, index) => {
          item.style.setProperty('--aos-animate-delay', `${index * 0.09}s`);
        });
    });
  };

  const getTargets = () => [...document.querySelectorAll('[data-cc-animate]:not(.cc-animate-in)')];

  if (!('IntersectionObserver' in window)) {
    getTargets().forEach(reveal);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.16
  });

  const observeAll = () => {
    assignStaggerDelays();

    getTargets().forEach((element) => {
      const rect = element.getBoundingClientRect();

      if (rect.top < window.innerHeight && rect.bottom > 0) {
        reveal(element);
        return;
      }

      observer.observe(element);
    });
  };

  observeAll();
  document.addEventListener('shopify:section:load', observeAll);
})();
